import { Base } from './base'

class API extends Base { }

export default API
